export default "__VITE_ASSET__DOSdd_O8__"